export interface ISVGProps {
  size?: number
  color?: string
  bgColor?: string
}

export function FollowUpIcon({
  size = 22,
  color = '#fff',
  bgColor,
}: ISVGProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
    >
      {bgColor && <circle cx="12" cy="12" r={11} fill={bgColor} />}

      <g
        fill="none"
        stroke={color}
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path d="M7.9 20A9 9 0 1 0 4 16.1L2 22Z" />
        <path d="m10 15-3-3 3-3" />
        <path d="M7 12h7a2 2 0 0 1 2 2v1" />
      </g>
    </svg>
  )
}
